import {RETRIEVE_MY_TASK_DETAIL} from "../../actions/types";
const initialState = {};

function myTaskDetailReducer(myTaskDetail = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case RETRIEVE_MY_TASK_DETAIL:
            return payload;
        default:
            return myTaskDetail;
    }
}

export default myTaskDetailReducer;
